import type { FC } from 'react';

import { useHost } from '@xing-com/crate-xinglet';

import { ParentConfiguration } from './components/parent-configuration/parent-configuration';
import { PlayerView } from './components/player-view/player-view';

export const App: FC = () => {
  const host = useHost();

  if (host.isServer) {
    host.setHeader(
      'content-security-policy',
      "frame-src 'self' *.xing.com; frame-ancestors 'self' *.xing.com"
    );
  }

  return (
    <>
      <ParentConfiguration>
        {({ configuration }) => <PlayerView configuration={configuration} />}
      </ParentConfiguration>
    </>
  );
};
